var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.642,
    height: 29.958,
    viewBox: "0 0 24.642 29.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#6868bf}.cls-2{fill:none;stroke:#6868bf}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_242",
    "data-name": "Grupo 242",
    transform: "translate(-50.679 -141.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_verified_user_24px",
    d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9z",
    className: "cls-1",
    transform: "translate(51 144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_verified_user_24px-2",
    d: "M14.821 1L3 6.254v7.881C3 21.424 8.044 28.241 14.821 29.9c6.777-1.655 11.821-8.472 11.821-15.761V6.254z",
    className: "cls-2",
    "data-name": "ic_verified_user_24px",
    transform: "translate(48.179 140.552)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTr);
export default __webpack_public_path__ + "static/media/icon_tr.88e97622b87cc8762375cc83c8fd3f6d.svg";
export { ForwardRef as ReactComponent };